import AuthPromptPlaceholder from './AuthPromptPlaceholder';

export default AuthPromptPlaceholder;
